<agpr-dialog-container
    id="devicePreviewDialog"
    heading="Discover.distribution.preview.device"
    [modal]="true"
    [draggable]="false"
    [contentPadding]="false"
    (close)="closeDialog()"
>
    <div class="agpr-devicePreview-container">
        <div class="agpr-devicePreview-button-container">
            <div class="agpr-devicePreview-button-alignmentButtons agpr-devicePreview-button" role="radiogroup">
                <agpr-radio
                    id="devicePreview.buttons.desktop"
                    name="device_select"
                    [value]="screenTypes.desktop"
                    [style]="radioTypesEnum.button"
                    [icon]="'fa-desktop'"
                    [iconTooltip]="'Discover.distribution.preview.desktop.tooltip' | localize"
                    tooltipPosition="right"
                    [(ngModel)]="selectedScreenType"
                    (onClick)="changeSelectedScreenType(screenTypes.desktop)"
                ></agpr-radio>
                <agpr-radio
                    id="devicePreview.buttons.tabletPortrait"
                    name="device_select"
                    [value]="screenTypes.tabletPortrait"
                    [style]="radioTypesEnum.button"
                    [icon]="'fa-tablet-screen-button'"
                    [iconTooltip]="'Discover.distribution.preview.tabletPortrait.tooltip'| localize"
                    tooltipPosition="right"
                    [(ngModel)]="selectedScreenType"
                    (onClick)="changeSelectedScreenType(screenTypes.tabletPortrait)"
                ></agpr-radio>
                <agpr-radio
                    id="devicePreview.buttons.tabletLandscape"
                    name="device_select"
                    [value]="screenTypes.tabletLandscape"
                    [style]="radioTypesEnum.button"
                    [icon]="'fa-tablet-screen-button landscape'"
                    [iconTooltip]="'Discover.distribution.preview.tabletLandscape.tooltip' | localize"
                    tooltipPosition="right"
                    [(ngModel)]="selectedScreenType"
                    (onClick)="changeSelectedScreenType(screenTypes.tabletLandscape)"
                ></agpr-radio>
                <agpr-radio
                    id="devicePreview.buttons.mobilePortrait"
                    name="device_select"
                    [value]="screenTypes.mobilePortrait"
                    [style]="radioTypesEnum.button"
                    [icon]="'fa-mobile-screen-button'"
                    [iconTooltip]="'Discover.distribution.preview.mobilePortrait.tooltip' | localize"
                    tooltipPosition="right"
                    [(ngModel)]="selectedScreenType"
                    (onClick)="changeSelectedScreenType(screenTypes.mobilePortrait)"
                ></agpr-radio>
                <agpr-radio
                    id="devicePreview.buttons.mobileLandscape"
                    name="device_select"
                    [value]="screenTypes.mobileLandscape"
                    [style]="radioTypesEnum.button"
                    [icon]="'fa-mobile-screen-button landscape'"
                    [iconTooltip]="'Discover.distribution.preview.mobileLandscape.tooltip' | localize"
                    tooltipPosition="right"
                    [(ngModel)]="selectedScreenType"
                    (onClick)="changeSelectedScreenType(screenTypes.mobileLandscape)"
                ></agpr-radio>
            </div>
            <agpr-dropdown
                *ngIf="selectedScreenType !== screenTypes.desktop"
                [options]="scaleOptions"
                [(ngModel)]="scale"
                (ngModelChange)="resize()"
                ariaLabel="Discover.distribution.preview.scale"
            ></agpr-dropdown>
        </div>
        <agpr-scroll-panel>
            <div
                class='agpr-devicePreview-screenWrapper'
                [ngStyle]="{
                    width: scaledWidth + 'px',
                    height: scaledHeight + 'px'
                }"
            >
                <div
                    class="agpr-devicePreview-screenPreview"
                    [ngClass]="{
                        'agpr-devicePreview-screenPreview--mobilePortrait' : selectedScreenType === screenTypes.mobilePortrait,
                        'agpr-devicePreview-screenPreview--mobileLandscape' : selectedScreenType === screenTypes.mobileLandscape,
                        'agpr-devicePreview-screenPreview--tabletLandscape' : selectedScreenType === screenTypes.tabletLandscape,
                        'agpr-devicePreview-screenPreview--tabletPortrait' : selectedScreenType === screenTypes.tabletPortrait,
                        'agpr-devicePreview-screenPreview--desktop' : selectedScreenType === screenTypes.desktop
                    }"
                    [ngStyle]="{
                        transform: 'scale(' + actualScale + ')'
                    }"
                >
                    @if (body) {
                        <iframe
                            class="agpr-devicePreview-frame"
                            [srcdoc]="body | sanitizeHtml"
                            [title]="'Discover.distribution.preview.device' | localize"
                        ></iframe>
                    }
                </div>
            </div>
        </agpr-scroll-panel>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            label="Core.button.cancel"
            id="devicePreviewDialog.cancelButton"
            [style]="buttonTypes.secondary"
            (click)="cancelClicked();"
        >
        </agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            id="devicePreviewDialog.doneButton"
            label="done"
            [style]="buttonTypes.primary"
            (click)="cancelClicked()"
        >
        </agpr-button>
    </ng-template>
</agpr-dialog-container>
